import CallbackForm from "./CallbackForm";
import BookTrialForm from "./BookTrialForm";

import { useAppSelector } from "@/hooks";

interface OneOnOneYogaFormProps {
  showModal?: boolean;
  setShowModal?: (showModal: boolean) => void;
}

const OneOnOneYogaForm: React.FC<OneOnOneYogaFormProps> = ({
  showModal,
  setShowModal = () => {},
}) => {
  const { data } = useAppSelector((state) => state.bootCamp);

  let form = <CallbackForm showModal={showModal} setShowModal={setShowModal} />;

  if (data?.trialData) {
    form = <BookTrialForm showModal={showModal} setShowModal={setShowModal} />;
  }

  return form;
};

export default OneOnOneYogaForm;
